import { render, staticRenderFns } from "./NuevaActividad.vue?vue&type=template&id=3c4ddcf3&scoped=true&"
import script from "./NuevaActividad.vue?vue&type=script&lang=js&"
export * from "./NuevaActividad.vue?vue&type=script&lang=js&"
import style0 from "./NuevaActividad.vue?vue&type=style&index=0&id=3c4ddcf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ddcf3",
  null
  
)

export default component.exports